module.exports = __webpack_public_path__ + "static/img/01-banner.3701636.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/05-recruit/01-banner.jpg
// module id = Vpap
// module chunks = 1